<template>
	<div class="StockCountDeliveries">
		<!-- <el-button
			icon="el-icon-arrow-left"
			type="warning"
			style="width:auto; margin:10px;"
			size="mini"
			@click="$router.go(-1)"
		>
			Previous Page
		</el-button> -->
		<div class="table-heading">
			Upload Stock Count
		</div>
		<div class="m-4">
			<simplebar class="simplebar">
				<table class="tableMain">
					<thead>
						<tr>
							<th colspan="1" class="border-right">
								Item
							</th>
							<th colspan="1" class="border-right">
								PO Date
							</th>
							<th colspan="1" class="border-right">
								PO
							</th>
							<th colspan="1" class="border-right">
								Batch No
							</th>
							<th colspan="1" class="border-right">
								Batch Date
							</th>
							<th colspan="1" class="border-right">
								Expiry
							</th>
							<th colspan="4" class="border-right">
								Qtd Ordered
							</th>
							<th colspan="4" class="border-right">
								Qtd Received
							</th>
							<th colspan="4" class="border-right">
								Variance
							</th>
							<th colspan="1" class="border-right">
								Reason
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in 8" :key="index">
							<td>
								<div style="min-width: 40px;">
									Item 1
								</div>
							</td>
							<td class="custom-elementUi-css">
								<el-date-picker
									v-model="expiryDate"
									type="date"
									size="mini"
									placeholder="PO Date"
								/>
							</td>
							<td class="custom-elementUi-css">
								<BaseInput
									v-model="systemCountPackQty"
									custom-class="p-2 text-sm  text-amp-input-boxes"
									placeholder="PO No"
								/>
							</td>
							<td class="custom-elementUi-css">
								<BaseInput
									v-model="systemCountPackQty"
									custom-class="p-2 text-sm text-amp-input-boxes"
									placeholder="Batch No"
								/>
							</td>
							<td class="custom-elementUi-css">
								<el-date-picker
									v-model="expiryDate"
									type="date"
									size="mini"
									placeholder="Batch Date"
								/>
							</td>
							<td class="custom-elementUi-css">
								<el-date-picker
									v-model="expiryDate"
									type="date"
									size="mini"
									placeholder="Expiry Date"
								/>
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="systemCountPack" placeholder="Pack">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="systemCountLoose" placeholder="Loose">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="actualCountPack" placeholder="Pack">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="actualCountLoose" placeholder="Loose">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="varianceCountPack" placeholder="Pack">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="varianceCountLoose" placeholder="Loose">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
							<td class="custom-elementUi-css">
								<el-input-number v-model="num" size="mini" />
							</td>
							<td class="custom-elementUi-css">
								<el-select v-model="reason" placeholder="Reason">
									<el-option
										v-for="item in 5"
										:key="item"
										:label="item"
										:value="item"
									/>
								</el-select>
							</td>
						</tr>
					</tbody>
				</table>
			</simplebar>
			<div class=" flex justify-end items-center p-2 pr-4">
				<BaseButton class="mr-8" buttonclass="btn py-1.5 px-4 text-sm">
					Save Count
				</BaseButton>
				<div>
					<el-pagination
						background
						:page-sizes="[5, 10, 15]"
						layout="sizes, prev, pager, next"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
export default {
	name: "StockCountDeliveries",
	components: {
		simplebar
	},
	data() {
		return {
			systemCountPack: "",
			systemCountPackQty: "",
			systemCountLoose: "",
			systemCountLooseQty: "",
			actualCountPack: "",
			actualCountPackQty: "",
			actualCountLoose: "",
			actualCountLooseQty: "",
			varianceCountPack: "",
			varianceCountPackQty: "",
			varianceCountLoose: "",
			varianceCountLooseQty: "",
			reason: "",
			expiryDate: "",
			expiryDateQty: "",
			num: 2
		};
	}
};
</script>

<style lang="scss" scoped>
@import "./StockCountDeliveries.scss";
</style>

<style>
.StockCountDeliveries .Baseinput input {
	height: 30px !important;
	width: 80px;
}
</style>
